import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as getters from './getters'
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: true,
    api_token: null,
    settingRecord: {},
    // user: {name: 'User', role: {name: 'User'}},
    user: {},
    profile: {},
    // imageBaseUrl: 'https://demo.micromuneem.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://demo.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://superbond.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://cresco.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://gnl.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.surahafinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://swapnashikha.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://pushpak.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://surendra.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://smfcash.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://demo.incrediblemicro.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.ezeepayfinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://microfinance.smegrowthmicrofoundation.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://foridofinance.com/demo/system/public/storage/',
    // imageBaseUrl: 'https://app.aonemicrofinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://mahilasakti.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://bullet.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://utkrast.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://utkrastmf.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://siyamicro.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://gagret.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://aglfmfi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://aglfoundation.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://pava.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mrp.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.janshaktimicrofinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.dotinfinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://rkc.microfinancesoftware.in/backend/system/public/storage/',
    imageBaseUrl: 'https://shorishahahfinance.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://vidhaan.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://swapnapurti.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://gagret1.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://jansuvidha.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://sanwariya.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://udaanlo.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://fingold.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://rewadi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.eonmicrofinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://dazzelloans.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://manisha.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://guddu.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.finmoneymicro.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.zascofinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://youfirst.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://kvav.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://helpgroup.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://simanchal.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://raghunandan.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://jsavior.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://siddhi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.supergoldmicro.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://app.worthrichmicrofinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://raunak.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://ruds.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://ekam.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://laxminivas.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://manaina.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://dhanvarsha.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://pblmilap.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://udyog.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://twink.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://ommsai.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://auc.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://laxmi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://tripursundari.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://shreenidhi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mtfs.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://lm.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://rkseva.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://nsg.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://dhanush.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://a1secure.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://growth.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://shrimangal.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://shrisai.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://savera.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://arshgroups.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://benstar.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://hooda.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://jcramg.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://gramin.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://multiple.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://khushpratap.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://goldway.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://klomshy.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://pankajsairam.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://arihant.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://sitara.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://shreeganesh.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://shreeganesh.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://shreya.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://diamond.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://magicgallery.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mauli.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://rsr.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://tridev.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://supergsg.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://khushi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mks.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://hst.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://darshika.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://virat.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://rockmount.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://supervision.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://ghoomar.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mitrsewa.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://jeevika.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://star.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://goldindia.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://quickpahal.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://finbase.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://aadharshila.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://dspl.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://dhanratna.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://dhairya.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://unnati.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://sakhi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://rdbi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://jts.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://swaraj.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://hoodafinancehrm.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://radhaiurban.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://finmantra.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://kiran.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mj.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://vardaan999.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://er.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://vda.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://bm.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://incredible.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mfutkrast.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://kakasastore.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://parangat.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://aviral.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://manikanta.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://progati.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://progati.micromuneem.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://goldwayfinance.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://jansathimf.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://dgmf.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://bmcf.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://prathanam.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://divine.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://mahotsav.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://janashakti.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://almf.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://triplambed.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://sgfc.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://sgfc.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://bpn.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://fundwell.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://kanakprit.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://supervisionmf.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://rmfs.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://vedantindia.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://rt.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://ts.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://nkc.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://ms.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://usfinance.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://growwell.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://growwell.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://svr.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://janbhawna.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://anand.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://dmf.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://janchetna.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://harshvardhan.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://fincare.13squad.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://esb.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://helpindia.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://demo.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://yatricapital.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://postpy.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://grouploan.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://mrpgrowth.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://dhanmitra.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://janaadarsh.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://rbsr.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://shreeram.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://gramsevamicrofinance.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://sarthi.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://ujjalsansar.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://pfs.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://loknidhi.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://rsw.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://kktrading.microfinancesoftware.in/backend/system/public/storage/',
    // imageBaseUrl: 'https://gcf.microfinsoftware.com/backend/system/public/storage/',
    // imageBaseUrl: 'https://finroute.microfinsoftware.com/backend/system/public/storage/',
    // imageDefaultUrl: 'https://via.placeholder.com/',
    imageDefaultUrl: 'https://www.russorizio.com/wp-content/uploads/2016/07/ef3-placeholder-image.jpg',
    permissions: []
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setProfile (state, payload) {
      state.profile = payload
    },
    setPermissions (state, payload) {
      state.permissions = payload
    },
    setApi_token (state, payload) {
      state.api_token = payload
    },
    setSettingRecords (state, payload) {
      state.settingRecord = payload
    }
  },
  actions,
  getters,
  modules,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/vuex/store.js